import type { ReactNode } from 'react'

type Props = {
  title: ReactNode
  crumb?: ReactNode
  primary?: ReactNode
  secondary?: ReactNode
}

export function PageHead({ title, crumb, primary, secondary }: Props) {
  return (
    <header className="page-head">
      <h1>{title}</h1>
      {crumb && <span className="crumb">{crumb}</span>}
      <div className="spacer" />
      {secondary}
      {primary}
    </header>
  )
}
